import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CaseWebsiteContext from "../context/websitecontext";
import { useTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import { Divider, ListItem } from "@material-ui/core";
import { ICaseData, IMilestone } from "../types";
import MilestoneItem from "./MilestoneItem";

const useStyles = makeStyles({
  root: {
    padding: "1em",
    margin: "1em",
  },
});

interface Props {
  milestones: IMilestone[];
}
const Milestones: React.FC<Props> = ({ milestones }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Typography color="primary" variant="h5">
        {t("Important Dates")}
      </Typography>
      <Divider />
      <List dense>
        {milestones.map((milestone: IMilestone, index: number) => {

          return <ListItem key={milestone.MilestoneWebId}
            divider={index + 1 !== milestones.length}>
            <MilestoneItem milestone={milestone} />

          </ListItem>
        })}
      </List>
    </Paper>
  );
};

export default React.memo(Milestones);
